// Generated by CoffeeScript 2.7.0
var CollaboratorsSelect;

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default CollaboratorsSelect = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  components: {
    'user-item': UserItem
  },
  template: `<popover-group-options wrapperClass='collaborators-edit-container'
                       optionsFilterPlaceholder='搜索用户'
                       :initialSelectedOptionIds='initialSelectedCollaboratorIds'
                       :formatDataFunc='formatCollaborators'
                       ref='popoverGroupOptionsRef'
                       @cancelClicked='cancelFunc'
                       @submitClicked='submitFunc'
                       @optionsChanged='optionsChangedFunc'
                       @valueChanged='valueChangedFunc'
                       @keywordUpdated='keywordUpdatedFunc'>
  <template slot='option-item-template' slot-scope='{ option }'>
    <div class='content'>
      <user-item :user='{ name: option.name, headimgurl: option.headimgurl }'
                 customClass='collaborator-item'
                 size='small' />
    </div>
    <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
    </div>
  </template>

  <div slot='filter-blankslate' class='list-group'>
    <div class="list-group-name">没有相关的搜索结果</div>
  </div>

  <div slot='options-blankslate' class='list-group'>
    <div class="list-group-name">没有相关的搜索结果</div>
  </div>
</popover-group-options>`,
  props: {
    initialSelectedCollaboratorIds: {
      type: Array
    },
    storeCollaboratorInstances: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      recentCollaborators: [],
      selectedCollaboratorIds: _.clone(this.initialSelectedCollaboratorIds),
      selectedCollaborators: []
    };
  },
  watch: {
    initialSelectedCollaboratorIds: function(val, oldVal) {
      this.selectedCollaboratorIds = _.clone(val);
      this._updateSelectedAttr();
      return this.$nextTick(function() {
        return this.$refs.popoverGroupOptionsRef.reset();
      });
    }
  },
  mounted: function() {
    if (this.storeCollaboratorInstances) {
      this._initializeSelectedCollabortars();
    }
    return this._initializeRecentCollabortars();
  },
  methods: {
    formatCollaborators: function() {
      return this.__generateRecentCollaboratorsOptions();
    },
    keywordUpdatedFunc: function(keyword) {
      if (_.isEmpty(keyword)) {
        return this._useRecentCollaborators();
      } else {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('users/query', {
          name: keyword,
          excluded_ids: [currentUser.id]
        }), {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: (data, xhr) => {
            return this.$refs.popoverGroupOptionsRef.updateGroupedOptions([
              {
                id: Skylark.Helpers.Utilities.uuid(),
                options: _.each(data,
              (collaborator) => {
                  return collaborator._selected = _.contains(this.selectedCollaboratorIds,
              collaborator.id);
                })
              }
            ]);
          }
        });
      }
    },
    valueChangedFunc: function(collaborator) {
      this.selectedCollaboratorIds = this.$refs.popoverGroupOptionsRef.selectedOptionIds;
      if (this.storeCollaboratorInstances) {
        return this._updateSelectedCollaborator(collaborator);
      }
    },
    reset: function() {
      this.selectedCollaboratorIds = _.clone(this.initialSelectedCollaboratorIds);
      return this.$nextTick(function() {
        return this.$refs.popoverGroupOptionsRef.reset();
      });
    },
    submitFunc: function() {
      return this.$emit('submitClicked', this.selectedCollaboratorIds);
    },
    _updateSelectedAttr: function() {
      _.each(this.recentCollaborators, (collaborator) => {
        return collaborator._selected = _.contains(this.selectedCollaboratorIds, collaborator.id);
      });
      if (this.storeCollaboratorInstances) {
        this.selectedCollaborators = _.filter(this.selectedCollaborators, (collaborator) => {
          return collaborator._selected = _.contains(this.selectedCollaboratorIds, collaborator.id);
        });
        return this._initializeSelectedCollabortars(this.selectedCollaboratorIds, _.difference(_.pluck(this.selectedCollaborators, 'id')));
      }
    },
    _initializeSelectedCollabortars: function(collaborator_ids = this.initialSelectedCollaboratorIds) {
      if (!_.isBlank(collaborator_ids)) {
        return new Skylark.Libs.PaginatedResources(Skylark.Helpers.UrlHelper.adminUrlFor('users'), {
          params: {
            ids: collaborator_ids
          },
          callback: (data) => {
            return _.each(data, (collaborator) => {
              collaborator._selected = true;
              return this._updateSelectedCollaborator(collaborator);
            });
          }
        });
      }
    },
    _initializeRecentCollabortars: function() {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor("users/recent_collaborators"), {
        responseType: 'json',
        success: (data) => {
          this.recentCollaborators = _.each(data, function(user) {
            return user._selected = false;
          });
          return this._useRecentCollaborators();
        }
      });
    },
    _updateSelectedCollaborator: function(collaborator) {
      var isIncluded;
      isIncluded = _.any(this.selectedCollaborators, function(user) {
        return user.id === collaborator.id;
      });
      if (collaborator._selected) {
        if (!isIncluded) {
          return this.selectedCollaborators.push(collaborator);
        }
      } else {
        if (isIncluded) {
          return this.selectedCollaborators = _.reject(this.selectedCollaborators, function(user) {
            return user.id === collaborator.id;
          });
        }
      }
    },
    _useRecentCollaborators: function() {
      return this.$refs.popoverGroupOptionsRef.updateGroupedOptions(this.__generateRecentCollaboratorsOptions());
    },
    __generateRecentCollaboratorsOptions: function() {
      return [
        {
          id: Skylark.Helpers.Utilities.uuid(),
          name: '常用协作者',
          options: _.each(this.recentCollaborators,
        (collaborator) => {
            collaborator._selected = _.contains(this.selectedCollaboratorIds,
        collaborator.id);
            if (this.storeCollaboratorInstances) {
              return this._updateSelectedCollaborator(collaborator);
            }
          })
        }
      ];
    }
  }
});
